class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    const facetClosers = this.querySelectorAll('.drawer-facets__closer');
    if (facetClosers.length) {
      // facetClosers.forEach((elem) => elem.addEventListener('click', closeActiveDetails));
    }

    const drawerToggleButton = document.querySelector('.drawer-facets__open');
    const drawerMenu = document.querySelector('#FacetFiltersFormMobile');
    const drawerOverlay = document.querySelector('.drawer-facets__overlay');
    if (drawerToggleButton && drawerMenu) {
      drawerMenu.closeMenuDrawer = function () {
        document.querySelector('body').classList.remove('is-drawer-facets-open');
        drawerMenu.classList.remove('is-open');
      };
      drawerMenu.openMenuDrawer = function () {
        document.querySelector('body').classList.add('is-drawer-facets-open');
        drawerMenu.classList.add('is-open');
      };
      drawerMenu.toggleMenuDrawer = function () {
        if (drawerMenu.classList.contains('is-open')) {
          drawerMenu.closeMenuDrawer();
        } else {
          drawerMenu.openMenuDrawer();
        }
      };
      if (!drawerToggleButton.classList.contains('bind-event')) {
        drawerToggleButton.classList.add('bind-event');
        drawerToggleButton.addEventListener('click', drawerMenu.toggleMenuDrawer.bind(this));
        drawerOverlay.addEventListener('click', drawerMenu.closeMenuDrawer.bind(this));

        // 絞り込みボタン
        const drawerFilterButtons = document.querySelectorAll('.drawer-facets__filterButton');
        [...drawerFilterButtons].forEach((button) => {
          button.addEventListener('click', (e) => {
            function doScroll() {
              const target = document.querySelector('.product-grid-container');
              if (target) {
                target.scrollIntoView(true, {
                  behavior: 'smooth',
                });
              }
            }
            setTimeout(doScroll, 400);
            drawerMenu.closeMenuDrawer();
          });
        });
      }

      const headerFacetDetails = this.querySelectorAll('.header-facets details');
      if (headerFacetDetails.length) {
        function closeAllDetails() {
          [...headerFacetDetails].forEach((elem) => {
            elem.removeAttribute('open');
          });
        }
        [...headerFacetDetails].forEach((elem) => {
          elem.addEventListener('click', (e) => {
            if (e.target.tagName == 'LABEL' || e.target.closest('label')) {
              return;
            }
            e.preventDefault();
            const current_target = e.currentTarget;
            const is_target_open = current_target.open;
            drawerMenu.closeMenuDrawer();
            closeAllDetails();
            if (!is_target_open) {
              current_target.setAttribute('open', 'true');
            }
          });
        });
        drawerToggleButton.addEventListener('click', closeAllDetails);
      }
    }
  }

  static dragStart(e) {
    const _target = e.target;
    if (_target.closest('.drawer-facets')) {
      this._pos_y = 0;
      this._dragStartY = e.touches != null ? e.touches[0].clientY : e.clientY;
      this._dragHistory = [
        {
          position: e.clientY,
          time: performance.now(),
        },
      ];
      // console.log('START:', this._dragStartY);
      this.style.transitionDuration = '0ms';
    }
  }

  static dragMove(e) {
    if (this._dragStartY != null) {
      // console.log(e);

      const currentY = e.touches != null ? e.touches[0].clientY : e.clientY;
      this._dragHistory.push({
        position: currentY,
        time: performance.now(),
      });
      if (this._dragHistory.length > 1) {
        const _len = this._dragHistory.length;
        const _point0 = this._dragHistory[_len - 2];
        const _point1 = this._dragHistory[_len - 1];

        const dt_y = _point1.position - _point0.position;
        const dt_time = _point1.time - _point0.time;
        // console.log('SPEED:', dt_y / dt_time);
      }
      // console.log('TOTAL:', currentY - this._dragStartY);
      // this.style.transform = `translateY(${currentY - this._dragStartY}px)`;
      requestAnimationFrame(FacetFiltersForm.containerMove.bind(this));
    }
  }

  static containerMove() {
    if (this._dragHistory != null && this._dragHistory.length > 1) {
      const _len = this._dragHistory.length;
      const _point1 = this._dragHistory[_len - 1];
      const pos_target = Math.min(Math.max(-50, _point1.position - this._dragStartY), this.offsetHeight - 40);
      this._pos_y = this._pos_y + (pos_target - this._pos_y) * 0.05;

      this.style.transform = `translateY(${this._pos_y}px)`;
      requestAnimationFrame(FacetFiltersForm.containerMove.bind(this));
    }
  }

  static dragEnd(e) {
    // console.log(e);
    if (this._dragHistory != null && this._dragHistory.length > 1) {
      const _len = this._dragHistory.length;
      const _point0 = this._dragHistory[_len - 2];
      const _point1 = this._dragHistory[_len - 1];

      const dt_y = _point1.position - _point0.position;
      const dt_time = _point1.time - _point0.time;
      const speed = dt_y / dt_time;
      // console.log('FINAL SPEED:', speed);
      // console.log('TOTAL:', _point1.position - this._dragStartY);

      this.style.cssText = '';

      if (speed > 0.1 || _point1.position - this._dragStartY > 100) {
        if (typeof this.closeMenuDrawer == 'function') {
          this.closeMenuDrawer();
        }
      }
    }

    // RESET
    this._dragStartY = null;
    this._dragHistory = [];
  }

  static closeDrawerAndScroll() {}

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);

    const container = document.querySelector('.drawer-facets');
    document.addEventListener('touchstart', FacetFiltersForm.dragStart.bind(container));
    document.addEventListener('mousedown', FacetFiltersForm.dragStart.bind(container));
    document.addEventListener('mousemove', FacetFiltersForm.dragMove.bind(container));
    document.addEventListener('touchmove', FacetFiltersForm.dragMove.bind(container));
    document.addEventListener('touchend', FacetFiltersForm.dragEnd.bind(container));
    document.addEventListener('mouseup', FacetFiltersForm.dragEnd.bind(container));
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', FacetFiltersForm.closeDrawerAndScroll.bind(container));
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static dispatchRenderEvent() {
    const event = new Event('reload_products');
    document.dispatchEvent(event);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.dispatchRenderEvent();
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('drawer-facets__details')
          ? `.drawer-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.drawer-facets__open', '.drawer-facets__header', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    // document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.drawer-facets__list');
    const sourceFacetsList = source.querySelector('.drawer-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.replaceState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
    );
    // history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'drawer-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
